import React, { useEffect, useState } from "react";
import { getSubscriptionsByType } from "../../../../services/apiservices/support";
import Spinner from "../../../../components/ui/spinner";


const PlanCard = ({ label, type, dateFilter }) => {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setCount(0);
    setLoading(true);

    getSubscriptionsByType(dateFilter, type).then((data) => {
      setCount(data?.length || 0);
      setLoading(false);
    });
  }, [dateFilter, type]);

  return (
    <div className="bg-[#232834] p-16 rounded-lg">
      <div className="flex justify-between items-start">
        <div>
          <p className="text-gray-400 text-sm">{label}</p>
          <p className="text-2xl font-bold">
            {loading ? <Spinner size="sm" /> : count}
          </p>
        </div>
      </div>
    </div>
  );
};


export const NewPlans = ({ dateFilter }) => (
  <PlanCard label="New Plans" type="new" dateFilter={dateFilter} />
);

export const RenewPlans = ({ dateFilter }) => (
  <PlanCard label="Renewed Plans" type="renew" dateFilter={dateFilter} />
);

export const CancelledPlans = ({ dateFilter }) => (
  <PlanCard label="Cancelled Plans" type="cancel" dateFilter={dateFilter} />
);
